/**
 * The words the dashboard uses about `/triage link` (Galley #30422), kept in
 * one place so the how-to next to "Slack: not linked" (`SlackLinkStatus`) and
 * the page it sends people to (`LinkSlack`) can't drift apart.
 *
 * `LINK_CODE_MINUTES` must equal `CODE_TTL_MINUTES` in
 * `src/worker/slack_link/mod.rs`, the lifetime of the private link
 * `/triage link` sends. A Rust test there reads this file and fails if they
 * differ, so keep its line exactly as `export const LINK_CODE_MINUTES = <n>;`.
 */
export const LINK_CODE_MINUTES = 15;

/** The confirm button's label on `/link/slack?code=…`. */
export const LINK_ACCOUNTS_LABEL = "Link accounts";
